export default `
clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
`
